import { Component, OnInit } from '@angular/core';
import { environment } from '../environments/environment';
import { BuildInfoService } from './shared/services/build-info.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'wipe-admin';

  constructor(private buildInfoService: BuildInfoService) {}

  ngOnInit() {
    // 🔍 Environment Confirmation Logging using BuildInfoService
    this.buildInfoService.logBuildInfo();
    
    // Add authentication flow debugging
    console.log('🚀 [AppComponent] ngOnInit - Application starting...');
    console.log('🚀 [AppComponent] Current URL at app start:', window.location.href);
    console.log('🚀 [AppComponent] Current pathname:', window.location.pathname);
    console.log('🚀 [AppComponent] Current search:', window.location.search);
    console.log('🚀 [AppComponent] Current hash:', window.location.hash);
    
    // Check localStorage state
    console.log('🚀 [AppComponent] LocalStorage state:');
    console.log('  - session token:', localStorage.getItem('session') ? 'EXISTS' : 'NULL');
    console.log('  - user:', localStorage.getItem('user') ? 'EXISTS' : 'NULL');
    console.log('  - isKeycloakLogin:', localStorage.getItem('isKeycloakLogin'));
    console.log('  - originalUrl:', localStorage.getItem('originalUrl'));
    
    // 🎯 Legacy logging for backward compatibility
    console.log('🏗️ BUILD ENVIRONMENT CONFIRMATION:');
    console.log('📄 Environment Source:', environment);
    console.log('🔧 Production Mode:', environment.production);
    console.log('🌐 Keycloak URL:', environment.keycloak.url);
    console.log('🔗 Gateway URL:', environment.gatewayUrl);
    console.log('🏢 Customer:', environment.customer);
    console.log('🚀 IAM Host:', environment.iamhost);
    
    // 🎯 Quick Environment Identifier
    if (environment.production === true && environment.iamhost.includes('assaying.qualix.ai')) {
      console.log('✅ CONFIRMED: Using PRODUCTION environment (environment.prod.ts)');
    } else if (environment.iamhost.includes('assaying-qa.qualix.ai')) {
      console.log('✅ CONFIRMED: Using QA environment (environment.qa.ts)');
    } else if (environment.iamhost.includes('assaying-dev.qualix.ai')) {
      console.log('✅ CONFIRMED: Using DEV environment (environment.dev.ts)');
    } else if (environment.iamhost.includes('localhost')) {
      console.log('✅ CONFIRMED: Using LOCAL environment (environment.ts or environment.local.ts)');
    } else {
      console.log('⚠️ UNKNOWN: Environment configuration not recognized');
    }
  }
}
